import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyAHymEGLkgyfzzuXxppifEuJ-5_301ULj8',
  authDomain: 'hess-f4f40.firebaseapp.com',
  databaseURL: 'https://hess-f4f40-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'hess-f4f40',
  storageBucket: 'hess-f4f40.firebasestorage.app',
  messagingSenderId: '606937054888',
  appId: '1:606937054888:web:5fa49d445f7a8754dc4c9d',
  measurementId: 'G-HTDT9BNJT8',
}

const app = initializeApp(firebaseConfig)

export const db = getDatabase(app)
